import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface IProps {
  customerId: string;
}

interface ChangeEmailBody {
  newEmail: string;
}

export const useChangeEmailMutation = (
  { customerId }: IProps,
  onSuccess: (response: any) => void,
  onError: (error: any) => void,
) => useMutation(
  'changeEmail',
  async ({ newEmail }: ChangeEmailBody) => {
    const { data } = await httpService.post(
      `${BASE_URL}/api/v1/user/${customerId}/email`,
      { email: newEmail },
    );
    return data;
  },
  {
    onSuccess: () => onSuccess(true),
    onError: (error: IServerErrorResponse) => {
      onError(flattenServerErrorResponse(error));
    },
  },
);
